// extracted by mini-css-extract-plugin
export default {"container":"_d1f768c0","result":"_2d795fee","listItem":"_c642a650","searchResultIcon":"_b582dc8b"};